// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"127":"500ff815","307":"4ae264fc","314":"4e25f3d5","745":"b833125a"}[chunkId] + ".js";
};